import React from 'react';
import './style.scss';

export interface DividerProps {
  vertical?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Divider: React.FC<DividerProps> = ({ vertical = false, className = '', style }) => {
  return (
    <div
      className={`divider${vertical ? ' divider-vertical' : ''} ${className}`}
      style={style}
    />
  );
};

export default Divider;